module.exports = import("https://storage.googleapis.com/courier-web-component/fullscreen-courier-chat.umd.js?etag=1112");;